import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import { Container} from 'react-bootstrap';

import "../css/home.css";
import OurServices from "../components/HomeOurServices";
import BestFeatures from "../components/HomeBestFeature";
import HomeHowItWorks from "../components/HomeHowItWorks";
// import Footer from "../components/Footer";

function Home() {
   const [active, setActive] = useState(null);

  const toggle = (id) => {
    setActive(active === id ? null : id);
  };

  const icon = (id) => (active === id ? "−" : "+");

useEffect(() => {
  slides.forEach((slide) => {
    const img = new Image();
    img.src = slide.image;
  });
}, []);

  useEffect(() => {
  if (window.location.hash) {
    const id = window.location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500); // wait for DOM + external scripts to load
    }
  }
}, []);

  const navigate = useNavigate();
useEffect(() => {
  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false;

      script.onload = resolve;
      script.onerror = reject;

      document.body.appendChild(script);
    });
  };

  const loadAllScripts = async () => {
    try {
      // ✅ Load in correct order
      await loadScript("/plugins/jquery-1.11.1.min.js");

      // expose globally (IMPORTANT)
      window.jQuery = window.$;

      // await loadScript("/js/jquery-ui.min.js");
      await loadScript("/plugins/modernizr-2.6.2.min.js");
      await loadScript("/plugins/bootstrap/bootstrap.min.js");
      await loadScript("/plugins/jquery.singlePageNav.min.js");
      await loadScript("/plugins/jquery.fancybox.pack.js");
      await loadScript("/plugins/isotope.pkgd.min.js");
      await loadScript("/plugins/jquery.easing.min.js");
      await loadScript("/plugins/jquery.slitslider.js");
      await loadScript("/plugins/jquery.ba-cond.min.js");
      await loadScript("/js/responsee.js");
      await loadScript("/css/owl-carousel/owl.carousel.js");
     await loadScript("/js/template-scripts.js");
     await loadScript("/plugins/wow.min.js");
     await loadScript("/plugins/jquery.form.min.js");
     await loadScript("/plugins/jquery.validate.min.js");
     await loadScript("/js/main.js");
     await loadScript("https://cdn.jsdelivr.net/npm/bootstrap@5.3.1/dist/js/bootstrap.bundle.min.js");

      // ✅ INIT SLIDER AFTER EVERYTHING LOADS
      setTimeout(() => {
        if (window.$ && window.$.fn.slitslider) {
          window.$("#slider").slitslider();
        }
      }, 300);

    } catch (error) {
      console.error("Script loading error:", error);
    }
  };

  loadAllScripts();
}, []);

// 🔥 Slider Data
const slides = [
  {
    title: "AI-Powered Audio Descriptions",
    desc: " Bring your videos to life with clear, professional audio descriptions powered by AI." ,                   
    // class: "slider-1",
            image: "../images/assets/slider-02-ppYNYw1-.png",

  },
  {
    title: "Indian Sign Language Generation",
    desc: "Break barriers and build inclusion with sign language powered video with AI.",
    // class: "slider-2",
      image: "../images/assets/slider-03-ppYNYw1-.png",
  },
];
// useEffect(() => {
//   const interval = setInterval(() => {
//     setCurrent((prev) => (prev + 1) % slides.length);
//   }, 4000);

//   return () => clearInterval(interval);
// }, [slides.length]);
const [current, setCurrent] = useState(0);

useEffect(() => {
  const interval = setInterval(goToNext, 4000);
  return () => clearInterval(interval);
}, [current]); // Added 'current' as dependency to reset timer on manual click
const goToNext = () => {
  setCurrent((prev) => (prev + 1) % slides.length);
};

const goToPrev = () => {
  setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
};
// 🔥 State
  return (
   <>
        <Header />
    	<>
     <style>{`
.prev, .next {
  user-select: none; /* Prevents text selection on rapid clicking */
  -webkit-tap-highlight-color: transparent; /* Removes flicker on mobile */
}

        `}</style>
        // Inside your return() statement
<style>{`
  /* 1. Remove the default blue outline on click for all elements */
  *:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  /* 2. OPTIONAL: To keep it accessible, only show a subtle focus 
     when users are actually using a Keyboard (Tab key) */
  *:focus-visible {
    outline: 2px solid #2e3192; /* Use your brand blue color */
    outline-offset: 2px;
  }

  /* 3. Specifically target the prev/next arrows to ensure they are clean */
  .prev:focus, .next:focus {
    outline: none !important;
  }

  .prev, .next {
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
`}</style>

      <main className="site-content" id="home-main-content" role="main" aria-label="Main content">
        <div aria-live="polite" className="sr-only" id="slider-status">
  Slide loaded
</div>

        {/* ============================
            HOME SLIDER
        ============================== */}

       
<section  id="home-slider" className="hero-slider">

  {slides.map((slide, index) => (
  <div
  key={index}
  className={`hero-slide ${index === current ? "active" : ""}`}
  style={{
    backgroundImage: `url(${slide.image})`,
  }}
>
      <div className="overlay" />

      <div className="hero-content">
        <h1 className="animated fadeInDown">{slide.title}</h1>
        <p className="animated fadeInDown join-p">{slide.desc}</p>

        <button
          className="btn btn-blue btn-effect"
          onClick={() => navigate("/login")}
        >
          JOIN
        </button>
      </div>
    </div>
  ))}

  {/* 🔹 Arrows */}
  {/* <button
    className="prev"
    onClick={() =>
      setCurrent((prev) => (prev - 1 + slides.length) % slides.length)
    }
    aria-label="Previous Slide"
  >
    ❮
  </button>

  <button
    className="next"
    onClick={() =>
      setCurrent((prev) => (prev + 1) % slides.length)
    }
    aria-label="Next Slide"
  >
    ❯
  </button> */}
<button
  className="prev"
  onClick={goToPrev} // Use the function directly
  aria-label="Previous Slide"
>
  ❮
</button>

<button
  className="next"
  onClick={goToNext} // Use the function directly
  aria-label="Next Slide"
>
  ❯
</button>
  {/* 🔹 Dots */}
  <div className="dots">
    {slides.map((_, index) => (
      <span
        key={index}
        className={index === current ? "dot active" : "dot"}
        onClick={() => setCurrent(index)}
      />
    ))}
  </div>
</section>

        {/* ============================
            ABOUT
        ============================== */}

        <section id="about" role="region"
  aria-labelledby="about-heading">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 id="about-heading">What Application Provides</h2>
                  {/* <p>
                    Can your visually impaired (VI) patients read your
                    letters? This guidance has been produced to help you
                    prepare documents for VI people.
                  </p> */}
                  <p className="about-text">
                    Delivering inclusive video experiences through accurate audio descriptions 
                    for blind and low-vision users, and Indian Sign Language (ISL) gestures for the deaf community.
                  </p>
                </div>
              </div>

<div className="row justify-content-center">
  <div className="col-md-6 col-sm-6 col-xs-12 text-center">
      
    <a
      className="sl-next"
       aria-label="Login for users and experts"
         href="/login"
      // onClick={() => navigate("/login")}
      style={{ cursor: "pointer" }}
      title="For Login, Please Click here."
    >
      <div className="service-item" role="group" aria-labelledby="login-title">

        <div className="service-icon">
           <img
                  src="images/Login.jpg"
                  alt="Login option for registered users and experts"
                  width="100%"
                />
         
        </div>
        <h3 id="login-title">Login</h3>
        <p>( For User / Expert )</p>
      </div>
    </a>
  </div>
</div>      
            </div>
          </div>
        </section>
<BestFeatures />
<HomeHowItWorks />
   
        <section id="contact" role="region"
  aria-labelledby="contact-title">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center">
          <h2 id="contact-title">Write to us</h2>
                </div>
              </div>

              <div className="col-lg-12 contact-form">
                <form action="#" id="contact-form" method="post" aria-describedby="contact-instruction">
                   {/* Screen reader instruction */}
          <p id="contact-instruction" className="sr-only">
            All fields are required. Use Tab key to move between fields.
          </p>
                 
                 
                  <div className="input-field">
                    <label htmlFor="name">
                                {/* <label htmlFor="name">Your Name</label> */}

                       <input
              id="name"
              className="form-control"
              name="name"
              type="text"
              required
              aria-required="true"
              placeholder="Your Name..."
            />
                      {/* <input
                        className="form-control"
                        name="name"
                        placeholder="Your Name..."
                        type="text"
						defaultValue=""
                      /> */}
                    </label>
                  </div>

                  <div className="input-field">
                    <label htmlFor="email">
                      {/* <input
                        className="form-control"
                        name="email"
                        placeholder="Your Email..."
                        type="email"
						defaultValue=""
                      /> */}
<input
              id="email"
              className="form-control"
              name="email"
              type="email"
              required
              aria-required="true"
                                      placeholder="Your Email..."

            />

                    </label>
                  </div>

                  <div className="input-field">
                    <label htmlFor="subject">
  <input
              id="subject"
              className="form-control"
              name="subject"
              type="text"
              required
              aria-required="true"
               placeholder="Subject..."
            />

                      {/* <input
                        className="form-control"
                        name="subject"
                        placeholder="Subject..."
                        type="text"
						defaultValue=""
                      /> */}
                    </label>
                  </div>

                  <div className="input-field">
                    <label htmlFor="message">
                      {/* <textarea
                        className="hometextarea form-control"
                        name="message"
                        placeholder="Messages..."
						defaultValue=""
                      ></textarea> */}
                       <textarea
              id="message"
              className="hometextarea form-control"
              name="message"
              rows="4"
              required
              aria-required="true"
              placeholder="Messages..."
            ></textarea>
                    </label>
                  </div>

 {/* Success message – NVDA will auto announce */}
          <div
            className="success-ms"
            id="mail-success"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            Thank you. Your message has been sent successfully.
          </div>

                  {/* <div className="success-ms" id="mail-success">
                    Thank you. The Mailman has been sent.
                  </div> */}
                  {/* <div className="error-ms" id="mail-fail">
                    Sorry, Try later.
                  </div> */}
 {/* Error message – NVDA will auto announce */}
          <div
            className="error-ms"
            id="mail-fail"
            role="alert"
            aria-atomic="true"
          >
            Sorry, something went wrong. Please try again later.
          </div>
                  <button                     
                  aria-label="Send message"
                    className="btn btn-blue btn-effect"
                    id="submit"
                    type="submit"
                  >
                    Send
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    {/* <Footer /> */}
    {/* FOOTER */}
      <footer className="login-footer">
        <Container>
          <div className="footer-text">
            © {new Date().getFullYear()}  Amrita CREATE | AI Video Accessibility Platform
          </div>
        </Container>
      </footer>

<style>{`
 /* FOOTER */

        .login-footer {
          background: #ffffff;
          border-top: 1px solid #e5e5e5;
          padding: 12px 10px;
          flex-shrink: 0;
        }

        .footer-text {
          text-align: center;
          color: #4b5563;
          font-size: 14px;
          // letter-spacing: 0.3px;
          font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        }
           .footer-text {
            font-size: 0.82rem;
          }
        }

      `}</style>

    </>
    </>
  );
}

export default Home;
